import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// King Floyd's (b_2ytsec10es, advertiser 6775715154222277513).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (complete months Jul 2025 – Jul 2026; 13-month tenure). NEW_AND_RETURNING
// with separate (non-pooled) campaign budgets. Under-utilized archetype: only
// ~$200 of the $1,000 monthly budget is spent, with a 3.6x combined first-year
// ROAS and reorders returning ~7x. Monthly series + partial Aug 2026 live in
// realBrandData.ts.
export const advKingFloyds: FaireAdvertiserProfileEntity = {
  token: "adv_king_floyds",
  type: "advertiserProfile",
  archetype: "big-budget-under-utilized",
  displayName: "King Floyd’s",
  brandToken: "b_2ytsec10es",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 13,
  budget: {
    totalBudgetDollars: 1000,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 18,
    numReorderConversions: 6,
    numTotalConversions: 24,
    totalAdsSalesDollars: 9522,
    newCustomerAdsSalesDollars: 7718,
    reorderAdsSalesDollars: 1804,
    totalAdsSpendDollars: 2630,
    newCustomerAdsSpendDollars: 2372,
    reorderAdsSpendDollars: 258,
    newCustomerBestEstimateFirstYearRoas: 3.25,
    reorderRoas: 6.99,
    combinedFirstYearRoas: 3.62,
    // MANAGER_METRICS_BRAND_ORDERS: 26 orders on the new-customer campaign
    // (from 18 acquired customers) and 7 on the reorder campaign.
    numNewCustomerAdsOrders: 26,
    numReorderAdsOrders: 7,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 240,
      maxRecommendedBudgetDollars: 480,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_kf_new", "camp_kf_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
